import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RxComposite } from '../model/rx-composite';
import { RxButtonModule } from '@nrwl/rx-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rx-cookie-consent',
  templateUrl: './rx-cookie-consent.component.html',
  styleUrls: ['./rx-cookie-consent.component.scss'],
  imports: [CommonModule, RxButtonModule],
})
export class RxCookieConsentComponent extends RxComposite {
  constructor(public dialogRef: MatDialogRef<any>) {
    super();
  }

  public acceptClicked(): void {
    this.dialogRef.close();
  }

  public denyClicked(): void {
    this.dialogRef.close();
  }

  public preferencesClicked(): void {
    this.dialogRef.close();
  }
}
